var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classNames from 'classnames';
export function propReducer(props, ref, reducers) {
    var result = {
        classes: {},
        props: {},
        styles: {},
        variables: {}
    };
    for (var _i = 0, reducers_1 = reducers; _i < reducers_1.length; _i++) {
        var reducer = reducers_1[_i];
        if (reducer) {
            var res = reducer(props, ref);
            result.classes = __assign(__assign({}, result.classes), res.classes);
            result.props = __assign(__assign({}, result.props), res.props);
            result.styles = __assign(__assign({}, result.styles), res.styles);
            result.variables = __assign(__assign({}, result.variables), res.variables);
        }
    }
    return {
        classes: classNames(result.classes),
        props: result.props,
        styles: result.styles,
        variables: result.variables,
    };
}
